"use client";

import { c as _c } from "react/compiler-runtime";
import { cn } from "@repo/ui/utils";
import { Carousel, CarouselContent, CarouselItem, CarouselNavButtons, CarouselProgressBar, useCarousel } from "@repo/ui/carousel";
import { VisualWrapper } from "@/components/common/visual/visual.component";
import { RichTextCaption } from "@/components/common/rich-text/rich-text-caption.component";
import type { ImageCarouselSingleProps } from "./image-carousel-single.types";
import type { CarouselSlide } from "../image-carousel.types";
interface InnerProps {
  slides: CarouselSlide[];
}
function ImageCarouselSingleInner(t0) {
  const $ = _c(14);
  const {
    slides
  } = t0;
  const {
    selectedIndex
  } = useCarousel();
  const hasMultipleSlides = slides.length > 1;
  const caption = slides[selectedIndex]?.caption;
  let t1;
  if ($[0] !== slides) {
    t1 = slides.map(_temp);
    $[0] = slides;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <CarouselContent className="ml-0 h-full">{t1}</CarouselContent>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== hasMultipleSlides) {
    t3 = hasMultipleSlides && <div className="pointer-events-none absolute inset-x-0 bottom-0 z-10 px-4 pb-4 mobile:px-16 mobile:pb-16"><div className="pointer-events-auto flex items-center justify-between"><CarouselNavButtons breakpoint="mobile" /><CarouselProgressBar className="h-[6px] w-2/3 bg-white/50 mobile:h-2" indicatorClassName="inset-y-px bg-white" /></div></div>;
    $[4] = hasMultipleSlides;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <div className="relative grid aspect-390/260 tablet:aspect-1440/832">{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== caption) {
    t5 = caption && caption.length > 0 && <div data-testid="image-carousel-caption" className="px-6 pt-4 mobile:px-16 mobile:pt-6"><RichTextCaption richText={caption} /></div>;
    $[9] = caption;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <>{t4}{t5}</>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}
function _temp(slide) {
  return <CarouselItem key={slide.key} className="basis-full pl-0"><VisualWrapper visual={slide.visual} className="size-full" visualClassName="size-full" /></CarouselItem>;
}
export function ImageCarouselSingle(t0) {
  const $ = _c(7);
  const {
    slides,
    className
  } = t0;
  if (!slides || slides.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== className) {
    t1 = cn("w-full", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== slides) {
    t2 = <Carousel loop={true} duration={40}><ImageCarouselSingleInner slides={slides} /></Carousel>;
    $[2] = slides;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <section data-testid="image-carousel-single" className={t1}>{t2}</section>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}